<div class="message-input-wrapper-column" style="width: 100%">
  @if (!isExited) {
  @if (editingMessage) {
  <div class="edit-preview-bar px-2 py-2 mb-2 d-flex align-items-center justify-content-between">
    <div class="edit-preview-left-icon mr-2 flex-shrink-0">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="#7b94d5" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1l1-4l9.5-9.5z" stroke="#7b94d5" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="edit-preview-content d-flex flex-column overflow-hidden w-100">
      <span class="edit-to-label">Edit message</span>
      <span class="edit-message-preview text-truncate">{{ editingMessage.message || '' }}</span>
    </div>
    <button class="close-edit-btn btn btn-link text-muted p-0 ml-2 flex-shrink-0" (click)="cancelEdit()"
      title="Cancel Edit">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="#7b94d5"
          d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59L7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12L5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4" />
      </svg>
    </button>
  </div>
  }

  <div class="message-input-container d-flex align-items-center">

    <!-- WHATSAPP STYLE INPUT WRAPPER -->
    <div class="whatsapp-layout-container w-100 d-flex align-items-end">

      <!-- Main Input Pill -->
      <div class="input-pill">
        @if (replyingTo) {
        <div class="reply-container-outer d-flex align-items-center mb-1">
          <div class="reply-type-icon-inner mr-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="#4e85e2" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 17 4 12 9 7"></polyline>
              <path d="M20 18v-2a4 4 0 0 0-4-4H4"></path>
            </svg>
          </div>
          <div class="reply-preview-bar flex-grow-1 d-flex align-items-center justify-content-between overflow-hidden">
            <div class="reply-preview-content d-flex align-items-center overflow-hidden" style="min-width: 0; flex: 1;">

              @if (getReplyThumbnail(replyingTo) && !replyThumbnailError) {
              <img [src]="getReplyThumbnail(replyingTo)" alt="Reply Thumb" class="reply-thumbnail" (error)="onReplyThumbnailError()" />
              }
              <div class="d-flex flex-column ml-2 overflow-hidden" style="min-width: 0; flex: 1;">
                <span class="reply-to-label text-truncate" style="display: block; width: 100%;">
                  {{ getReplySenderName(replyingTo) }}
                  @if (replyingTo.sourceGroupName) {
                    <span class="reply-source-group ml-1" style="font-size: 11px; font-weight: normal;">• {{ replyingTo.sourceGroupName }}</span>
                  }
                </span>
                <div class="d-flex align-items-center message-preview-text" style="min-width: 0; width: 100%;">
                  @if (getReplyMediaType(replyingTo) === 'Voice Message') {
                  <svg class="mr-1 media-type-icon" viewBox="0 0 24 24" width="14" height="14" style="flex-shrink: 0;">
                    <path fill="currentColor"
                      d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                    <path fill="currentColor"
                      d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                  </svg>
                  } @else if (getReplyMediaTypeIcon(replyingTo)) {
                  <img class="mr-1 media-type-icon" [src]="getReplyMediaTypeIcon(replyingTo)" style="flex-shrink: 0;" />
                  }
                  <span class="text-truncate" style="font-size: 13px; flex: 1; min-width: 0;">{{ getReplyMessageText(replyingTo) }}</span>
                </div>
              </div>
            </div>
            <button class="close-reply-btn-outer btn btn-link text-muted px-2 py-0 ml-1" (click)="cancelReply()"
              title="Cancel Reply">
              <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24">
                <path fill="#4e85e2"
                  d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59L7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12L5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
                  stroke-width="0.5" stroke="#4e85e2" />
              </svg>
            </button>
          </div>
        </div>
        }

        <!-- Left Actions -->
        @if (!isRecordingVoice) {
        <div class="left-actions d-flex align-items-center">
          <!-- Attach Menu Trigger -->
          <div class="attach-menu-wrapper position-relative">
            <button class="action-trigger attach-btn" (click)="toggleAttachMenu()" [class.active]="showAttachMenu"
              title="Attachments">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </button>

            <!-- Attach Menu (WhatsApp Style) -->
            @if (showAttachMenu) {
            <div class="attach-menu-tooltip">
              <div class="menu-item doc" (click)="triggerDocumentInput(hiddenFileInput)">
                <div class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                  </svg>
                </div>
                <span>Document</span>
              </div>
              <div class="menu-item media" (click)="triggerPhotosVideoInput(hiddenFileInput)">
                <div class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5"></circle>
                    <polyline points="21 15 16 10 5 21"></polyline>
                  </svg>
                </div>
                <span>Photos & videos</span>
              </div>
              <div class="menu-item camera" (click)="openCamera()">
                <div class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                    <circle cx="12" cy="13" r="4"></circle>
                  </svg>
                </div>
                <span>Camera</span>
              </div>
              <div class="menu-item audio" (click)="triggerAudioInput(hiddenFileInput)">
                <div class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 18V5l12-2v13"></path>
                    <circle cx="6" cy="18" r="3"></circle>
                    <circle cx="18" cy="16" r="3"></circle>
                  </svg>
                </div>
                <span>Audio</span>
              </div>
              <div class="menu-item gif" (click)="toggleGif()">
                <div class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                    <text x="5" y="15" font-size="10" font-weight="900" fill="currentColor" stroke="none">GIF</text>
                  </svg>
                </div>
                <span>GIFs</span>
              </div>
            </div>
            }
          </div>

          <!-- Emoji Trigger -->
          <button class="action-trigger emoji-btn" (click)="toggleEmoji()" [class.active]="showEmojiPicker"
            title="Emojis">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
              <line x1="9" y1="9" x2="9.01" y2="9"></line>
              <line x1="15" y1="9" x2="15.01" y2="9"></line>
            </svg>
          </button>
        </div>
        }

        <!-- Text Input Wrapper -->
        @if (!isRecordingVoice) {
        <div class="whatsapp-textarea-wrapper position-relative">
          @if (showFormattingBar) {
          <div class="formatting-toolbar-floating" (mousedown)="$event.preventDefault()">
            <button type="button" class="format-btn" (click)="applyTextFormatting('bold')" title="Bold (Ctrl+B)">
              <b>B</b>
            </button>
            <button type="button" class="format-btn" (click)="applyTextFormatting('italic')" title="Italic (Ctrl+I)">
              <i>I</i>
            </button>
            <button type="button" class="format-btn" (click)="applyTextFormatting('strikethrough')" title="Strikethrough (Ctrl+Shift+X)">
              <s>S</s>
            </button>
            <button type="button" class="format-btn" (click)="applyTextFormatting('code')" title="Inline Code (Ctrl+Shift+M)">
              <span class="mono-symbol">&lt;/&gt;</span>
            </button>
            <div class="format-divider"></div>
            <button type="button" class="format-btn spoiler-btn" (click)="applyTextFormatting('spoiler')" title="Hidden text / Spoiler (Ctrl+Shift+P)">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
              <span>Hidden</span>
            </button>
            <button type="button" class="format-btn" (click)="applyTextFormatting('quote')" title="Quote">
              <span>&ldquo;&rdquo;</span>
            </button>
          </div>
          }
          <textarea #messageInput [ngModel]="message" (ngModelChange)="onModelChange($event)" (input)="onInput($event)"
            (keydown)="onKeyDown($event)" (paste)="onPaste($event)"
            (select)="onTextareaSelection($event)" (mouseup)="onTextareaSelection($event)" (keyup)="onTextareaSelection($event)"
            (blur)="onTextareaBlur($event)"
            class="whatsapp-textarea" rows="1"
            [attr.enterkeyhint]="isMobile ? 'enter' : null"
            [placeholder]="selectedGifUrl ? 'Add a caption...' : placeholder"></textarea>
        </div>
        } @else {
        <div class="voice-recording-wrapper w-100 d-flex align-items-center justify-content-between">
          <!-- Trash Icon (Left) -->
          <button class="btn btn-link text-muted p-0 d-flex align-items-center flex-shrink-0"
            (click)="cancelVoiceRecording()" title="Cancel">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </button>

          <!-- Recording Content (Right aligned) -->
          <div class="d-flex align-items-center" style="color: var(--text-primary, #111b21);">
            <span class="recording-dot"></span>
            <span class="recording-time mx-3" style="font-family: monospace; font-size: 1rem;">{{
              getFormattedVoiceTime() }}</span>

            <!-- Waveform dummy -->
            <div class="waveform d-flex align-items-center mr-3"
              style="gap: 3px; height: 24px; overflow: hidden; opacity: 0.7;">
              <div class="wave-bar" style="height: 40%"></div>
              <div class="wave-bar" style="height: 70%"></div>
              <div class="wave-bar" style="height: 100%"></div>
              <div class="wave-bar" style="height: 50%"></div>
              <div class="wave-bar" style="height: 80%"></div>
              <div class="wave-bar" style="height: 30%"></div>
              <div class="wave-bar" style="height: 90%"></div>
              <div class="wave-bar" style="height: 60%"></div>
              <div class="wave-bar" style="height: 40%"></div>
              <div class="wave-bar" style="height: 70%"></div>
              <div class="wave-bar" style="height: 100%"></div>
              <div class="wave-bar" style="height: 80%"></div>
              <div class="wave-bar" style="height: 30%"></div>
              <div class="wave-bar" style="height: 90%"></div>
              <div class="wave-bar" style="height: 60%"></div>
              <div class="wave-bar" style="height: 40%"></div>
              <div class="wave-bar" style="height: 70%"></div>
              <div class="wave-bar" style="height: 100%"></div>
              <div class="wave-bar d-none d-sm-block" style="height: 50%"></div>
              <div class="wave-bar d-none d-sm-block" style="height: 80%"></div>
              <div class="wave-bar d-none d-sm-block" style="height: 30%"></div>
              <div class="wave-bar d-none d-sm-block" style="height: 90%"></div>
            </div>

            <!-- Send Button -->
            <button class="inner-send-btn flex-shrink-0" (click)="stopAndSendVoiceRecording()" title="Send">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 2L11 13" stroke="#4e85e2" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="#4e85e2" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        }

        <!-- Right Actions: Swap Mic and Send -->
        @if (!isRecordingVoice) {
        <div class="right-actions-inside">
          @if (!message || message.trim().length === 0) {
          <button class="mic-trigger" title="Voice Message" (click)="startVoiceRecording()">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
              <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
              <line x1="12" y1="19" x2="12" y2="23"></line>
              <line x1="8" y1="23" x2="16" y2="23"></line>
            </svg>
          </button>
          } @else {
          <button class="inner-send-btn" (click)="messageSent.emit($event)" (mousedown)="$event.preventDefault()"
            [disabled]="isSending">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 2L11 13" stroke="#4e85e2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="#4e85e2" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
          }
        </div>
        }

        <!-- Hidden file input -->
        <input #hiddenFileInput type="file" style="display: none" (change)="handleFileInput($event)" multiple />
      </div>

    </div>
    <!-- Mention Dropdown -->
    @if (isGroup && showMentionList) {
    <div class="mention-dropdown">
      @for (
      user of mentionUsers;
      track user.userId
      ) {
      <div class="mention-item" [class.mention-item-active]="mentionActiveIndex === $index"
        tabindex="0" (mousedown)="$event.preventDefault()" (click)="selectMention(user)"
        (mouseenter)="mentionActiveIndex = $index">
        @if (user.userId === '__all__') {
          <div class="mention-avatar mention-all-icon">&#64;</div>
        } @else {
          <img [src]="user.profileImage || 'assets/user-icon.png'" (error)="handleProfileImageError($event)"
            class="mention-avatar" width="30" height="30" />
        }
        <div class="mention-item-text">
          <span class="mention-item-name">
            {{ user.displayName || user.name || user.userName }}
          </span>
          @if (user.userId === '__all__') {
            <span class="mention-all-sub">Mention all members in group chat</span>
          }
        </div>
      </div>
      }
    </div>
    }


  </div>
  }

  @if (isExited) {
  <div class="d-flex align-items-center justify-content-center exited-group-message p-3 text-center" style="
          background: #f2f9ff;
          border-top: 1px solid #eee;
          color: #666;
          font-size: 14px;
        ">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 8px; vertical-align: middle">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    <p class="mb-0">
      You can't send messages to this group because you are no
      longer a member
    </p>
  </div>
  }

  <!-- GIF Panel -->
  @if (showGifPanel) {
  <app-gif-panel [visible]="showGifPanel" (gifSelected)="selectGif($event)" (closed)="toggleGif()"></app-gif-panel>
  }


  <!-- Emoji Picker Panel -->
  @if (showEmojiPicker) {
  <div class="emoji-panel-container">
    <div class="emoji-panel">
      <emoji-mart (emojiClick)="addEmoji($event); $event.stopPropagation()" [skin]="1" [showPreview]="false"
        [enableSearch]="true" [emojiSize]="24" [perLine]="8" [color]="'#00a884'" title=""></emoji-mart>
    </div>
  </div>
  }


</div>